<template>
  <div class="common-ticket-table">
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="14">
        <el-row  :gutter="10">
          <el-col :span="10">
            <el-input
              :placeholder="$locale('form.plsEnterYourName')"
              v-model="filter.name"
              @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="filter_fn">{{
              $locale("global.search")
            }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="search-item ta-r" v-if="isSuperAdmin">
        <el-button class="egl-btn-yellow" @click="showDetailDailog">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" class="egl-table list-table" stripe>
      <el-table-column
        :prop="th.prop"
        :label="th.label"
        v-for="th in thead"
        :key="th.prop"
        :min-width="th.width"
        :align="th.align"
        :formatter="th.formatter"
        ></el-table-column>
        <el-table-column :label="$locale('global.control')" min-width="180" align="center">

        <template slot-scope="scope">
          <div class="handle">
            <a @click="viewTicketDetail(scope.row)">{{ $locale("global.detail") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="editTicketDetail(scope.row)">{{ $locale("global.edit") }}</a>
            <el-divider v-if="isSuperAdmin" direction="vertical"></el-divider>
            <a v-if="isSuperAdmin" @click="deleteTicketDetail(scope.row, 'delete')">{{ $locale("global.delete") }}</a>
          </div>
        </template>

      </el-table-column>

    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />

    <Dialog
      v-bind:action="action"
      v-bind:formData="selectedFormData"
      v-bind:versionList="versionList"
      v-bind:authority="authority"
      @closeFn="closeDetailDailog"
      @returnMsg="confirmAction"
    ></Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Movie/MovieTicketDialog";
import CommPagination from "@/components/common/CommPagination";
import { mapGetters, mapState, mapActions } from "vuex";
import { localStorage } from "@/utils/localStorage";
import { requestAll } from "@/helpers/service/axiosPlugin";
import { getClientListService } from "@/helpers/service/api/common";
import { getVersionService } from "@/helpers/service/api/version";
import {
  deleteMovieTicket,
  getMoviTicketListService,
  updateMovieTicket,
  getMovieTicket,
  createMovieTicket,
} from "@/helpers/service/api/movie";
import { getFilmList } from "@/helpers/service/api/report";
import tranfResData from "@/utils/tranfResData";
import {
  toThousands,
  reverseThousandsFn,
  adminTypeList,
  // formInvalidHandle,
  toTableRowDateFormat,
  revertToTableDateFormat
} from "@/utils/common";
import  {
  ticketUtilizeObj,
  ticketCoordinationObj,
  listApiTypeMapping,
  noneOption,
  checkValidData,
} from "@/assets/js/movieStatic";
import countDownAlert from "@/utils/countDownAlert";

export default {
  name: "common-ticket-table",
  componentName: "commonTable",
  data() {
    return {
      onSearch: {
        name: "",
        baseType: "",
        page: 0,
        pageSize: 10
      },
      filter: {
        name: "",
        baseType: ""
      },
      pageCount: 0,
      thead: [
        {
          prop: "createTime",
          label: this.$locale("global.date"),
          width: 150,
          formatter: (row, column, cellValue) => toTableRowDateFormat(cellValue),
          deformatter: revertToTableDateFormat
        },
        {
          prop: "name",
          label: this.$locale("global.name"),
          width: 200
        },
        {
          prop: "clientId",
          label: this.$locale("accountReceivable.client"),
          width: 250,
          formatter: row => {
            const clientObj = this.tempClientList.find(item => item.id === row.clientId);
            return clientObj ? clientObj.name : ""; }
        },
        {
          prop: "boxOfficeAmount",
          label: this.$locale("couponLib.amountOfBoxOfficeRevenue"),
          width: 100,
          formatter: (row, column, cellValue) => toThousands(cellValue),
          deformatter: reverseThousandsFn
        },
        {
          prop: "sellAmount",
          label: this.$locale("movie.ticketMaster.sellAmount"),
          width: 100,
          formatter: (row, column, cellValue) => toThousands(cellValue),
          deformatter: reverseThousandsFn
        },
        // {
        //   prop: "actualAmount",
        //   label: this.$locale("couponLib.ticketPrintAmount"),
        //   width: 100,
        //   formatter: (row, column, cellValue) => toThousands(cellValue),
        //   deformatter: reverseThousandsFn
        // },
        {
          prop: "ticketingCode",
          label: this.$locale("movie.codeOfMulberry"),
          width: 100
        },
        {
          prop: "useNumber",
          label: this.$locale("movie.numOfUsers"),
          width: 100
        },
        {
          prop: "category",
          label: this.$locale("movie.mvtk.category"),
          width: 100,
          formatter: (row, column, cellValue) => {
            return cellValue === '01' ? '全国共通券' : '劇場券'
          },
        },
      ],
      tableData: [],
      action: "",
      adminTypeList,
      formData: { movieTicketInfoList: [] },
      selectedFormData: {},
      distributorOptions:[],
      versionList: [],
      tempClientList: [],
      isLoading: false,
      pageSize: 10,
      currentPage: 0,
      isSubmit: false,
      movieId: "",
    };
  },
  props: {
    authority: {
      type: Object,
      default: () => ({
        type: null,
        edit: false,
        add: false,
        del: false,
        editFields: [],
      }),
    },
    movieTicketList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters("app", [ "isSuperAdmin" ]),
    ...mapState("app", {
      _adminType: state => state.adminType,
      _cinemaId: state => state.cinemaId,
      _brandId: state => state.brandId,
    }),
    ...mapState("api", {
      _pageCount: state => state.pageCount,
      clientList: state => state.clientList
    }),
    adminType() {
      return this._adminType ? this._adminType : localStorage.get("adminType");
    },
    cinemaId() {
      return this._cinemaId ? this._cinemaId : localStorage.get("cinemaId");
    },
    brandId() {
      return this._brandId ? this._brandId : localStorage.get("brandId");
    },
    apiTypeFromParent() {
      return this.getApiType();
    }
  },
  inject: ["reload", "apiTypeForChildren", "getApiType"],
  async created() {
    // await this.getPageData();
    this.isLoading = false;
  },
  mounted() {
    this.movieId = this.$route.params.id || "";
    this.tableData = this.movieTicketList;
    let _ids = [];
    this.movieTicketList.forEach(item => {
      if (item.clientId) {
        _ids.push(item.clientId);
      }
    });
    getClientListService({
      ids: _ids,
      page: 0,
      pageSize: 9999,
      field: ["id", "name"],
    }).then(clientRes => {
      this.tempClientList = clientRes.data.data;
    });
    this.pageCount = this._pageCount;
  },
  methods: {
    ...mapActions("api", [ "setPageCount" ]),
    filter_fn() {
      this.onSearch = { ...this.onSearch, ...this.filter, page: 0 };
      this.getMVTKPageData();
    },
    showDetailDailog() {
      this.action = "create";
    },
    closeDetailDailog() {
      this.dailogDetailMsg = {};
      this.action = "";
    },
    async getTicketDetail(ticketId) {
      return await (await getMovieTicket(ticketId, (this.movieId ? { filmId: this.movieId } : {}))).data;
    },
    async viewTicketDetail(ticket) {
      // const ticketDetail = this.formatTicketData(await this.getTicketDetail(ticket.id));
      // const ticketDetail = await this.getTicketDetail(ticket.id);
      // if (!ticketDetail) { return; }
      // this.selectedFormData = ticketDetail;
      await getMovieTicket(ticket.id).then(res => {
        this.selectedFormData = res.data;
        this.action = "view";
      });
      await getVersionService({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      }).then(res => {
        this.versionList = [{ id: "none", name: "なし" }, ...res.data.data];
      });
    },
    async editTicketDetail(ticket) {
      // const ticketDetail = this.formatTicketData(await this.getTicketDetail(ticket.id));
      // if (!ticketDetail) { return; }
      // this.selectedFormData = ticketDetail;
      await getMovieTicket(ticket.id).then(res => {
        this.selectedFormData = res.data;
        this.action = "edit";
      });
      await getVersionService({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      }).then(res => {
        this.versionList = [{
          id: "none",
          name: "なし",
        },...res.data.data];
      });
    },
    async deleteTicketDetail(ticket) {
      let confirmHtml = `
      <i class="egl-confirm-question">?</i>
      <span class="result-text">${this.$locale("global.delete")} ${ticket.name}</span>`;

      try {
        await this.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("global.delete"),
          customClass: "egl-confirm",
          closeOnClickModal: false,
        });

        const { success } = await deleteMovieTicket(ticket.id);
        if(success) {
          countDownAlert({
            content: this.$locale("global.deleteSuccessfully"),
            callback: () => {
              this.reload();
            }
          });
        }

      } catch (error) {
        console.error(error);
      }
    },
    choosePage(page) {
      this.onSearch = { ...this.onSearch, page: page - 1 };
      this.getMVTKPageData();
    },
    formatTicketData(ticket) {
      const formattedTicketData = JSON.parse(JSON.stringify(ticket));
      this.thead.forEach(h => {
        formattedTicketData[h.prop] = h.formatter ?
          h.formatter(ticket[h.prop]) :
          ticket[h.prop];
      });

      if (!formattedTicketData.usableVersion1 && this.versionList && this.versionList.length > 0) {
        formattedTicketData.usableVersion1 = JSON.parse(JSON.stringify(this.versionList))[0].id;
      }

      if (this.adminType !== adminTypeList.SUP_AMIN && formattedTicketData.checkMessages.length === 0) {
        formattedTicketData.checkMessages.push(tranfResData(ticketCoordinationObj));
      }
      formattedTicketData.clientName = formattedTicketData.clientId ? this.clientList.find(client => client.id === formattedTicketData.clientId).name : "";

      return formattedTicketData;
    },
    formatTicketListTableData(tableListData) {
      return tableListData.map(ticket => this.formatTicketData(ticket));
    },
    async getPageData() {
      this.isLoading = true;
      const [movieTicketInfoList, distributorOptions, versionList, clientList] = await requestAll([
        getMoviTicketListService({
          ...(this.brandId && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
          ...(this.cinemaId && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
          ...(this.movieId ? { filmId: this.movieId } : {}),
          page: this.onSearch.page,
          pageSize: this.onSearch.pageSize,
          type: !this.movieId ? listApiTypeMapping[this.adminType] : "film",
          name: this.onSearch.name
        }),
        getFilmList({
          dailyReport: false,
          cinemaId: this.brandId || "123", // NOTICE: here need to pass the brand ID actually
          startDate: "2022-01-01",
        }),
        getVersionService({
          cinemaId: this.cinemaId,
          page: 0,
          pageSize: 9999,
        }),
        getClientListService({
          page: 0,
          pageSize: 9999,
          field: ["id", "name"],
        })
      ]);

      this.pageCount = movieTicketInfoList.data.count;
      this.formData.movieTicketInfoList = [
        ...(this.adminType === adminTypeList.SUP_AMIN ? [ tranfResData(ticketUtilizeObj) ] : []),
        ...(movieTicketInfoList.data.data && movieTicketInfoList.data.data.length > 0 ? tranfResData(movieTicketInfoList.data.data) : []),
      ];
      this.distributorOptions = tranfResData(distributorOptions.data || []);
      this.versionList = [noneOption, ...tranfResData(versionList.data ? versionList.data.data : [])];
      this.clientList = clientList ? clientList.data.data : [];

      this.tableData = movieTicketInfoList.data ? this.formatTicketListTableData(tranfResData(movieTicketInfoList.data.data)) : [];
    },
    getMVTKPageData() {
      this.isLoading = true;
      getMoviTicketListService(
        this.$route.path.indexOf("create") > -1 ? {
          name: this.onSearch.name,
          ...(this.brandId && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
          ...(this.cinemaId && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
          type: listApiTypeMapping[this.adminType],
          pageSize: 10,
          page: 0,
        } : {
          ...(this.apiTypeFromParent === "global" && this.brandId && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
          ...(this.apiTypeFromParent === "global" && this.cinemaId && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
          ...(this.movieId && this.apiTypeFromParent === "film" ? { filmId: this.movieId } : {}),
          page: this.onSearch.page,
          pageSize: this.onSearch.pageSize,
          type: !this.movieId || this.apiTypeFromParent === "global" ? listApiTypeMapping[this.adminType] : "film",
          name: this.onSearch.name
        }).then(res => {
        this.pageCount = res.data.count;
        // this.formData.movieTicketInfoList = [
        //   ...(this.adminType === adminTypeList.SUP_AMIN ? [ tranfResData(ticketUtilizeObj) ] : []),
        //   ...(res.data.data && res.data.data.length > 0 ? tranfResData(res.data.data) : []),
        // ];
        // this.tableData = res.data ? this.formatTicketListTableData(tranfResData(res.data.data)) : [];
        let _data = tranfResData(res.data.data);
        let _ids = [];
        res.data.data.forEach(item => {
          if (item.clientId) {
            _ids.push(item.clientId);
          }
        });
        console.log(_ids);
        getClientListService({
          ids: _ids,
          page: 0,
          pageSize: 9999,
          field: ["id", "name"],
        }).then(clientRes => {
          this.tempClientList = clientRes.data.data;
          this.tableData = _data;
        });
      });
    },
    prepareSubmitTicketData(ticket) {
      const deformattedTicketData = tranfResData(ticket);
      // deformatting
      this.thead.forEach(config => {
        if (!config.formatter || !config.deformatter) { return; }
        deformattedTicketData[config.prop] = config.deformatter(deformattedTicketData[config.prop]);
      });
      // clean data
      delete deformattedTicketData.clientName;
      // deformattedTicketData.type = listApiTypeMapping[this.adminType];
      deformattedTicketData.type = this.$parent.$options.name === "movie-ticket-master" ? listApiTypeMapping[this.adminType] : "film";
      deformattedTicketData.checkMessages = deformattedTicketData.checkMessages.reduce((msgs, msg) => {
        return checkValidData(msg) ? [...msgs, msg] : msgs;
      }, []);
      if (this.$parent.$options.name !== "movie-ticket-master") {
        deformattedTicketData.filmId = deformattedTicketData.filmId ? deformattedTicketData.filmId : this.movieId;
      }

      return deformattedTicketData;
    },
    async confirmAction(ticket) {
      if (!["edit", "create"].includes(this.action)) {
        return;
      }

      this.isLoading = true;
      // preparing data for submission ...
      const movieTicketInfo = this.prepareSubmitTicketData(ticket);
      // this.closeDetailDailog();
      try {
        const { success } = await (() => {
          if (this.action === "edit") {
            return updateMovieTicket(movieTicketInfo);
          }
          if (this.action === "create") {
            return createMovieTicket(movieTicketInfo);
          }
        })();

        if (success) {
          this.closeDetailDailog();
          // countDownAlert({
          //   content: this.$locale("global.updateSuccessfully"),
          //   callback: () => {
          //     // this.reload();
          //     // this.getMVTKPageData();
          //   }
          // });
          getMoviTicketListService({
            ...(this.brandId && this.$parent.$options.name === "movie-ticket-master" && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
            ...(this.cinemaId && this.$parent.$options.name === "movie-ticket-master" && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
            ...this.$parent.$options.name !== "movie-ticket-master" ? { filmId: this.movieId } : {},
            page: this.onSearch.page,
            pageSize: this.onSearch.pageSize,
            type: this.$parent.$options.name === "movie-ticket-master" ? listApiTypeMapping[this.adminType] : "film",
          }).then(res => {
            this.pageCount = res.data.count;
            // this.formData.movieTicketInfoList = [
            //   ...(this.adminType === adminTypeList.SUP_AMIN ? [ tranfResData(ticketUtilizeObj) ] : []),
            //   ...(res.data.data && res.data.data.length > 0 ? tranfResData(res.data.data) : []),
            // ];
            // this.tableData = res.data ? this.formatTicketListTableData(tranfResData(res.data.data)) : [];
            // this.tableData = res.data ? tranfResData(res.data.data) : [];
            let _data = tranfResData(res.data.data);
            let _ids = [];
            res.data.data.forEach(item => {
              if (item.clientId) {
                _ids.push(item.clientId);
              }
            });
            getClientListService({
              ids: _ids,
              page: 0,
              pageSize: 9999,
              field: ["id", "name"],
            }).then(clientRes => {
              _data.forEach(item => {
                item.clientName = clientRes.data.data.find(client => client.id === item.clientId) ?
                  clientRes.data.data.find(client => client.id === item.clientId).name : "";
              });
              this.tableData = _data;
            });
          });
        }
      } catch (error) {
        console.error("failed to update ticket");
        console.error(error);
      }

    },
  },
  components: {
    Dialog,
    CommPagination,
  }
};
</script>
